import React from 'react';
import Box from '@mui/material/Box';

function PartnerFooter() {
  return (
    <Box
      component="footer"
      sx={{
        py: 2, // padding top and bottom
        px: 3, // padding left and right
        backgroundColor: 'info.main', // background color
        color: 'white', // text color        
      }}
    >
      ELO Partner Page
    </Box>
  );
}

export default PartnerFooter;
